<main class="page-main" [@slideOutLeftOnLeave]="true"  [@slideInRightOnEnter]="true">
  <div class="layout layout--login">
    <div class="layout__login">
        <div class="layout__login-inner">
          <div class="card card--login">
            <div class="card__heading">
              <div class="card__avatar">
                <img src="assets/0/avatar/happy.png" class="img-fluid" alt="">
              </div>
              <h3>{{flow?.header ? flow?.header : '...' }}</h3>

            </div>
            <div class="card-body">
              <div class="card__form">
                <p [innerHTML]="flow?.body ? flow?.body : 'Loading...'"></p>
               
              </div>

              <div class="card__btn">
                <a href="javascript:void(0);" (click)="moveOn()"
                   class="button button--center button--lg button--primary-gradient">
                 {{button?.button_text}}
                </a>
              </div>
            </div>
          </div>
        </div>
    </div>

    <div class="layout__login-extra">
      
    </div>
  </div>
</main>

<app-disclaimer></app-disclaimer>